import { TransferBaseRequestDto } from './transfer-base-request.dto';

export class ExternalTransferOnlyStructureDto extends TransferBaseRequestDto {
	public LoggingStyle: string;
	public sstnLoggingStyle: string;
	public businessUnit: string;

	public constructor(parameters: Partial<ExternalTransferOnlyStructureDto>) {
		super({
			Environment: parameters.Environment
		});

		this.LoggingStyle = parameters.LoggingStyle;
		this.sstnLoggingStyle = parameters.sstnLoggingStyle;
		this.businessUnit = parameters.businessUnit;
	}
}
